const TEMPLATE_NAME = 'PATIENT_LAST_VISITS';

const initialState = () => ({
    loading: false,
    data: [],
});

const reducer = (state = initialState(), action) => {
    switch (action.type) {
        case `${TEMPLATE_NAME}_PENDING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${TEMPLATE_NAME}_REJECTED`: {
            return {
                ...state,
                loading: false,
            };
        }
        case `${TEMPLATE_NAME}_FULFILLED`: {
            const data = action.payload;
            return {
                ...state,
                loading: false,
                data: data,
            };
        }
        default:
            return state;
    }
};

export default reducer;
